/**
 * Gốc URL của backend — tách riêng khỏi `boide-api.ts` để PHÁ VÒNG IMPORT.
 *
 * 🔴 `maintenance-config.ts` cần gọi `GET /v1/maintenance`, còn `boide-api.ts` lại
 * cần gọi `noteMaintenanceResponse` ở chỗ xử lý response chung. Để hằng này nằm
 * trong `boide-api.ts` là hai module import vòng nhau: ESM vẫn chạy nhờ live
 * binding, nhưng thứ tự khởi tạo do bundler quyết định, nên một ngày nào đó
 * `BOIDE_API_URL` có thể còn `undefined` lúc module kia đọc nó — và triệu chứng là
 * một lượt fetch tới `/v1/maintenance` trên chính origin của frontend, tức im lặng
 * không bao giờ phát hiện được bảo trì.
 *
 * `boide-api.ts` re-export lại hằng này nên mọi chỗ đang `import { BOIDE_API_URL }
 * from "@/lib/boide-api"` không phải sửa gì.
 */
export const BOIDE_API_URL =
  (import.meta.env.VITE_BOIDE_API_URL as string | undefined)?.replace(/\/$/, "") ||
  (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, "") ||
  "";

/**
 * Gốc URL của Account service (`account-be`) — phụ trách các API tài khoản
 * người dùng `/v1/users/*` (login, sign-up, profile, avatar, transactions…).
 * Tách riêng khỏi `BOIDE_API_URL` vì chạy trên host khác (account.boide.online).
 * Không đặt `VITE_BOIDE_ACCOUNT_API_URL` thì fallback về `BOIDE_API_URL` để
 * môi trường cũ vẫn chạy như trước.
 */
export const BOIDE_ACCOUNT_API_URL =
  (import.meta.env.VITE_BOIDE_ACCOUNT_API_URL as string | undefined)?.replace(/\/$/, "") ||
  BOIDE_API_URL;
